import { TransactionOrder } from "creso-core/types";
import { capitalize, isRecurringOrder } from "creso-core/utils";
import { format } from "date-fns";

export function OrderFrequency({ order }: { order: TransactionOrder }) {
  if (!isRecurringOrder(order)) return null;
  if (order.frequency === "DAILY")
    return (
      <span className="text-sm font-medium">{capitalize(order.frequency)}</span>
    );
  return (
    <span className="text-sm text-muted-foreground">
      {order.frequency && capitalize(order.frequency)} on{" "}
      {format(
        new Date(order.start_date as string),
        order.frequency === "WEEKLY" ? "EEE" : "do"
      )}
    </span>
  );
}
